import React from 'react';
import { useMultiStyleConfig } from '../../../../utils/use-style-config';
import { Box } from '../../Box';
import { jsx as _jsx } from "react/jsx-runtime";
export var SelectSingleValue = _ref => {
  var {
    children,
    isDisabled
  } = _ref;
  var styles = useMultiStyleConfig('Select', {});
  return /*#__PURE__*/_jsx(Box, {
    "data-component": "SelectSingleValue",
    "aria-disabled": isDisabled,
    __css: styles['singleValue'],
    children: children
  });
};
//# sourceMappingURL=SelectSingleValue.js.map